const OrderSummary = ({ items, subtotal = 0, taxAmount = 0, shippingRate = null, total = 0 }) => {
  return (
    <div className="border rounded-lg p-4 mb-6 bg-white">
      <h3 className="text-lg font-semibold mb-4">Order Summary</h3>
      
      {/* Display items */}
      {items.map((item) => (
        <div key={item.id} className="flex justify-between mb-2">
          <span>{item.name}</span>
          <span>${(item.price * item.quantity).toFixed(2)}</span>
        </div>
      ))}
      
      {/* Display totals */}
      <div className="border-t mt-4 pt-4">
        <div className="flex justify-between mb-2">
          <span>Subtotal:</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        {shippingRate && (
          <div className="flex justify-between mb-2">
            <span>Shipping ({shippingRate.service}):</span>
            <span>${shippingRate.rate.toFixed(2)}</span>
          </div>
        )}
        <div className="flex justify-between mb-2">
          <span>Tax:</span>
          <span>${taxAmount.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold">
          <span>Total:</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;